import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/api';

export const fetchMedia = createAsyncThunk(
  'media/fetchAll',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.media.getAll(params);
      const payload = response.data?.data;
      if (Array.isArray(payload)) return payload;
      if (payload && Array.isArray(payload.items)) return payload.items;
      return [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadMedia = createAsyncThunk(
  'media/upload',
  async ({ file, type }, { rejectWithValue }) => {
    try {
      const response = await apiService.media.upload(file, type);
      const raw = response.data.data;
      return {
        id: raw.filename,
        filename: raw.mediaFileName || raw.originalName || raw.filename,
        url: raw.mediaUrl,
        size: raw.mediaSize,
        mime: raw.mediaMimeType,
        uploadedAt: raw.uploadedAt,
        mediaHandle: raw.mediaHandle || null
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteMedia = createAsyncThunk(
  'media/delete',
  async (filename, { rejectWithValue }) => {
    try {
      await apiService.media.delete(filename);
      return filename;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  items: [],
  loading: false,
  uploading: false,
  error: null
};

const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMedia.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchMedia.fulfilled, (state, action) => { state.loading = false; state.items = action.payload; })
      .addCase(fetchMedia.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

      .addCase(uploadMedia.pending, (state) => { state.uploading = true; state.error = null; })
      .addCase(uploadMedia.fulfilled, (state, action) => { state.uploading = false; state.items.unshift(action.payload); })
      .addCase(uploadMedia.rejected, (state, action) => { state.uploading = false; state.error = action.payload; })

      .addCase(deleteMedia.fulfilled, (state, action) => {
        state.items = state.items.filter(i => i.id !== action.payload);
      })
      .addCase(deleteMedia.rejected, (state, action) => { state.error = action.payload; });
  }
});

export const { clearError } = mediaSlice.actions;
export default mediaSlice.reducer;
